import type { NodeDefinition } from "~/nodes/types";

export const addNode: NodeDefinition = {
  type: "add",
  label: "Add",
  category: "Math",
  inputs: [
    {
      key: "num1",
      label: "Number",
      socket: "number",
      control: { kind: "number", key: "num1", label: "num1" },
    },
    {
      key: "num2",
      label: "Number2",
      socket: "number",
      control: { kind: "number", key: "num2", label: "num2" },
    },
  ],
  outputs: [{ key: "num", label: "Number", socket: "number" }],
  controls: [{ kind: "preview", key: "preview", label: "sum" }],
  defaults: { num1: 1, num2: 1 },

  compute(ctx) {
    const sum = ctx.number("num1", 1) + ctx.number("num2", 1);

    ctx.preview("preview", sum);
    return { num: sum };
  },
};
